import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userName: "",
    userEmail: "",
    userPhoneNumber: "",
    role: "",
    token: "",
    refreshToken: "",
    refreshTokenExpiry: null,
    userId: "",
    finalBalance: 0,
    availableBalance: 0,
    otherCharges: 0,
    loading: false,
    showValues: true,
    payoutFormAccess: false,
  },

  reducers: {
    // Added reducer to toggle value visibility
    toggleValues: (state) => {
      state.showValues = !state.showValues;
    },
    resetValues: (state) => {
      state.showValues = true;
    },

    getItem: (state, action) => {
      return state[action.payload];
    },

    setItem: (state, action) => {
      const field = action.payload[0];
      const value = action.payload[1];

      return {
        ...state,
        [field]: value,
      };
    },

    removeItem: (state, action) => {
      const field = action.payload;
      if (field in state) {
        state[field] = "";
      }
    },

    logout: (state) => {
      state.userName = "";
      state.userEmail = "";
      state.userPhoneNumber = "";
      state.role = "";
      state.token = "";
      state.refreshToken = "";
      state.refreshTokenExpiry = null;
      state.userId = "";
      state.availableBalance = 0;
      state.finalBalance = 0;
      state.otherCharges = 0;
      state.loading = false;
      state.payoutFormAccess = false;
    },
  },
});

export const { toggleValues, resetValues } = userSlice.actions;
export const actions = userSlice.actions;

export default userSlice;